// extracted by css-extract-rspack-plugin
export default {"loading":"R3Zl4g"};